// extracted by mini-css-extract-plugin
export var menuItem = "L_vM d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "L_vN d_Z d_bz d_bP";
export var menuMainLink = "L_vP d_f0 d_dB";
export var menuLink = "L_vQ d_f0 d_dB";
export var icon = "L_n9 d_bC d_bP";
export var divider = "L_vR d_bC d_bP";
export var sublinks = "L_vS";
export var link = "L_mZ";
export var Link = "L_tw D_tw D_sN D_s6";